/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { modalController } from '@ionic/vue';
import NeedSubscription from '../components/NeedSubscription/NeedSubscription.vue';

const openNeedSubscriptionModalHandle = () => {
  const modalExist = document.querySelector('.needSubscriptionModal');
  if (!modalExist) {
    modalController
      .create({
        component: NeedSubscription,
        backdropDismiss: false,
        keyboardClose: false,
        cssClass: 'needSubscriptionModal',
      })
      .then((modalElement) => {
        modalElement.present();
      });
  }
};

export { openNeedSubscriptionModalHandle };
